import styled from '@emotion/styled'
import { css } from '@emotion/react'

const containerStyles = ({ theme }) => css`
  label: container;

  background: ${theme.colors.white};
  height: 470px;
  top: calc(79vh - (-10vh) - 470px);
  width: 100%;
  z-index: 2;
  display: flex;
  overflow-y: scroll;
  flex-direction: column;
  justify-content: space-between;
`

const itemStyles = ({ theme }) => css`
  label: container__item;

  padding: 0 ${theme.spacings.mega} ${theme.spacings.mega} ${theme.spacings.mega};
  margin-bottom: ${theme.spacings.mega};
  border-bottom: 1px solid ${theme.colors.n200};
`

const radioButtonStyles = ({ theme }) => css`
  label: container__radio-button;

  width: 20px;
  height: 20px;

  margin-right: ${theme.spacings.mega};

  appearance: none;
  cursor: pointer;

  border: 1px solid ${theme.colors.n500};
  border-radius: ${theme.borderRadius.circle};

  background: transparent;

  position: relative;
  transition: all 400ms ease-in-out;

  &::before {
    content: '';

    position: absolute;
    display: block;

    width: 45%;
    height: 45%;

    background: ${theme.colors.white};

    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    margin: auto;

    border-radius: ${theme.borderRadius.circle};
    opacity: 0;
    transition: all 400ms ease-in-out;
  }

  &:checked {
    background: green;

    &::before {
      opacity: 1;
    }
  }
`

const radioButtonLabelStyles = ({ theme, isActive }) => css`
  label: container__radio-button-label;

  display: flex;
  align-items: center;
`

const containerFooterStyles = () => css`
  label: container__footer;

  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 1) 70%,
    rgba(255, 255, 255, 0) 100%
  );
  top: calc(79vh - (-10vh) - 115px);
  width: 100%;
  height: 115px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const overlayStyles = () => css`
  label: container__overlay;

  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  background: black;
  opacity: 0.6;
  z-index: 1;
`

const titleStyles = ({ theme }) => css`
  label: container__title;

  display: block;

  margin: ${theme.spacings.peta} 0 ${theme.spacings.tera} 0;
  padding: 0 ${theme.spacings.mega};

  text-align: center;
  color: ${theme.colors.black};
  font-size: ${theme.typography.headings.giga.fontSize};
  line-height: ${theme.typography.headings.giga.lineHeight};
  font-weight: ${theme.font.weight.semibold};
`

const modalCloseStyles = ({ theme, isActive }) => css`
  label: container__modal-close;

  position: absolute;

  top: ${theme.spacings.mega};
  left: ${theme.spacings.mega};

  color: ${isActive ? theme.colors.white : theme.colors.n400};

  ${theme.media.giga} {
    display: none;
  }
`

export const Container = styled('div')(containerStyles)
export const Item = styled('li')(itemStyles)
export const RadioButton = styled('input')(radioButtonStyles)
export const RadioButtonLabel = styled('label')(radioButtonLabelStyles)
export const ContainerFooter = styled('div')(containerFooterStyles)
export const Overlay = styled('div')(overlayStyles)
export const Title = styled('span')(titleStyles)
export const ModalClose = styled('div')(modalCloseStyles)
